import { ApplicationRef, Component, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { first } from 'rxjs';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { ThemeService } from '@semai-soft.net/theme-ngx';

@Component({
  imports: [IonApp, IonRouterOutlet],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  protected title = 'cin-web-public-pwa';

  private appRef = inject(ApplicationRef);
  private updates = inject(SwUpdate);

  constructor() {
    inject(ThemeService);
    if (this.updates.isEnabled) {
      this.appRef.isStable
        .pipe(first((isStable) => isStable === true))
        .subscribe(async () => {
          try {
            const updateFound = await this.updates.checkForUpdate();
            if (updateFound) {
              this.updates
                .activateUpdate()
                .then(() => document.location.reload());
            }
          } catch {
            // noop
          }
        });
    }
  }
}
